export const PersonalEmail = 'E_MAIL_PRIVAT';
